const filterResultItem = (validationItem, typeCode, specificCodes, ignoreCodes) => validationItem
  && validationItem.code
  && validationItem.code.length > 3
  && validationItem.code.substring(0, 3) === typeCode
  && (!specificCodes || specificCodes.indexOf(validationItem.code) !== -1)
  && (!ignoreCodes || ignoreCodes.indexOf(validationItem.code) === -1);

export default class ValidationInspector {
  static filterValidationResults = (validationResultList, typeCode, specificCodes, ignoreCodes) => validationResultList
      && Array.isArray(validationResultList)
      && validationResultList.reduce((filteredResult, validationItem) => {
        if (filterResultItem(validationItem, typeCode, specificCodes, ignoreCodes)) {
          filteredResult.push(validationItem);
        }

        return filteredResult;
      }, []);

  static hasValidationItems = (validationResultList, typeCode, specificCodes, ignoreCodes) => validationResultList
    && Array.isArray(validationResultList)
    && validationResultList.some(validationItem => filterResultItem(validationItem, typeCode, specificCodes, ignoreCodes));

  static filterRecommendations = (validationResult, specificCodes, ignoreCodes) => (validationResult && ValidationInspector.filterValidationResults(validationResult.warnings, 'REC', specificCodes, ignoreCodes)) || null;

  static filterWarnings = (validationResult, specificCodes, ignoreCodes) => (validationResult && ValidationInspector.filterValidationResults(validationResult.warnings, 'WRN', specificCodes, ignoreCodes)) || null;

  static filterRejections = (validationResult, specificCodes, ignoreCodes) => (validationResult && ValidationInspector.filterValidationResults(validationResult.rejections, 'REJ', specificCodes, ignoreCodes)) || null;

  static hasWarnings = (validationResult, specificCodes, ignoreCodes) => validationResult && ValidationInspector.hasValidationItems(validationResult.warnings, 'WRN', specificCodes, ignoreCodes);

  static hasRejections = (validationResult, specificCodes, ignoreCodes) => validationResult && ValidationInspector.hasValidationItems(validationResult.rejections, 'REJ', specificCodes, ignoreCodes);
}
